module.exports = __webpack_public_path__ + "static/img/5508_phase_function_Paper_PointsHejduk_Prediction.5d0c0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5508_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Hjz+
// module chunks = 0